<div class="container">
  <ng-content select="[title]"></ng-content>
  <div class="label" *ngFor="let label of labels">
    <span class="color" [ngStyle]="{ 'background-color': label.color }">
      <i *ngIf="label.icon" class="icon-{{ label.icon }}"></i>
    </span>
    <p>{{ label.name }}</p>
  </div>
</div>
